import classNames from 'classnames/bind';
import Icon, { IconVariant } from 'src/components/ui-kit/icon/icon';
import { DetailedHTMLProps, LiHTMLAttributes } from 'react';
import styles from './success-list.module.scss';

const classesContext = classNames.bind(styles);

export default function SuccessListItem({
  children,
  className
}: DetailedHTMLProps<LiHTMLAttributes<HTMLLIElement>, HTMLLIElement>): JSX.Element {
  return (
    <li className={classesContext(['successlist_item', className])}>
      <Icon variant={IconVariant.CHECK} />
      {children}
    </li>
  );
}
